import { ApiService } from "../..";

export const getUserProfile = (role?: boolean, group?: boolean) => {
  return ApiService.baseAction(
    "auth/profile",
    {
      params: {
        role,
        group,
      },
    },
    "get"
  );
};
